<script>
import api from './api'
export default {
  load (id) {
    return api.getData('analytics/' + id)
  },
  save (id, formData) {
    if (!id) {
      return api.post('analytics', formData)
    }
    return api.put('analytics/' + id, formData)
  },
  remove (id) {
    return api.delete('analytics/' + id)
  },
  list (params) {
    return api.get('analytics', params)
  },
  download (id) {
    return api.download('analytics/' + id + '/download')
  },
  loadShare (id, params) {
    return api.get('analytics/' + id + '/share', params)
  },
  saveShare (id, params) {
    return api.post('analytics/' + id + '/share', params)
  },
  copy (srcId, dstId) {
    return api.post('analytics/' + srcId + '/copy_to/' + dstId)
  }
}
</script>



// WEBPACK FOOTER //
// analytics.vue?17dbf6ad